export default __webpack_public_path__ + "static/media/snakeEyes.ddea06a2.png";